function storeDownloadData(posix, max, array) {
  array.push({ x: posix, y: Math.round(max * 100) / 100 });
}

function readTextFile(file, callback) {
  var rawFile = new XMLHttpRequest();
  rawFile.overrideMimeType("application/json");
  rawFile.open("GET", file, true);
  rawFile.onreadystatechange = function () {
    if (rawFile.readyState === 4 && rawFile.status == "200") {
      callback(rawFile.responseText);
    }
  };
  rawFile.send(null);
}

window.downloadclick = function (
  elem,
  name,
  years,
  daysback,
  interval,
  numberinterval,
  sumormean,
  button,
  buttoncheck,
  minmax
) {
  document.getElementById("timeserieslength").innerHTML = years.toString();
  document.getElementById("numofinterval2").innerHTML =
    numberinterval.toString();

  if (sumormean.toString() == "sum") {
    document.getElementById("summean").innerHTML = sumormean.toString();
  } else if (sumormean.toString() == "summ") {
    sumormean = "sum";
  }
  if (sumormean.toString() == "mean") {
    document.getElementById("summean").innerHTML = sumormean.toString();
  } else if (sumormean.toString() == "meann") {
    sumormean = "mean";
  }

  if (sumormean.toString() == "sum") {
    document.getElementById("Aggregierung1").options.selectedIndex = 0;
  } else {
    document.getElementById("Aggregierung1").options.selectedIndex = 1;
  }
  if (minmax == 1)
    document.getElementById("Aggregierung1").options.selectedIndex = 2; //min=1
  if (minmax == 2)
    document.getElementById("Aggregierung1").options.selectedIndex = 3; //max=2

  document.getElementById("aggre").innerHTML = interval.toString();

  document.getElementById("Export1").disabled = false;

  if (buttoncheck == "1") {
    const buttons = document.querySelectorAll(".buttonA");
    buttons.forEach((butt) => {
      butt.style.backgroundColor = "#5b9ad5";
    });

    const buttonss = document.querySelectorAll(".buttonT");
    buttonss.forEach((butts) => {
      butts.style.backgroundColor = "#5b9ad5";
    });
    //document.getElementById(button).style.backgroundColor = '#4479ab';
    document.getElementById(button).style.backgroundColor = "#4479ab";

    if (button == "But5j1" || button == "But2j1") {
      document.getElementById("Export1").disabled = true;
    } else {
      document.getElementById("Export1").disabled = false;
    }
  } else if (buttoncheck == "2") {
    const buttons = document.querySelectorAll(".buttonT");
    buttons.forEach((butt) => {
      butt.style.backgroundColor = "#5b9ad5";
    });
    document.getElementById(button).style.backgroundColor = "#4479ab";
  } else if (buttoncheck == "3") {
    const buttons = document.querySelectorAll(".buttonT");
    buttons.forEach((butt) => {
      butt.style.backgroundColor = "#5b9ad5";
    });
    const buttonss = document.querySelectorAll(".buttonA");
    buttonss.forEach((butts) => {
      butts.style.backgroundColor = "#5b9ad5";
    });
  }

  ApexCharts.exec("downloaddata", "updateSeries", [{ data: [] }], true);
  const downloaddaten_median = [];
  const downloaddaten_min = [];
  const downloaddaten_max = [];
  var downloaddaten_graph = [];

  var dd = new Date(document.getElementById("Input_Date1b").value);
  var datePickerDate = new Date(document.getElementById("Input_Date1").value);
  var diffdate = Math.round(
    (dd.getTime() - datePickerDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  var DATUMP = document.getElementById("Input_Date1").value;

  if (interval == "P1H") {
    var d = new Date();
    var df = new Date();
    df.setDate(df.getDate() - 30);
    var monati = df.getMonth() + 1;
    if (monati < 10) {
      monati = "0" + (df.getMonth() + 1);
    }
    var tagi = df.getDate();
    if (tagi < 10) {
      tagi = "0" + df.getDate();
    }
    if (interval == "P1Y") {
      monati = "01";
      tagi = "01";
    }
    DATUMP = d.getFullYear() + "-" + monati + "-" + tagi;

    diffdate = Math.round((d.getTime() - df.getTime()) / (1000 * 60 * 60));
  }

  var numbInt = "R" + diffdate;

  //alert(numbInt+" "+diffdate+ " "+DATUMP);

  //alert('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+document.getElementById("station").innerHTML+'/sensors/'+elem+'/measurements?interval='+numbInt+'/'+DATUMP+'T00:00:00Z/'+interval+'&agg='+sumormean);

  readTextFile(
    "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
      document.getElementById("station").innerHTML +
      "/sensors/" +
      elem +
      "/measurements?interval=" +
      numbInt +
      "/" +
      DATUMP +
      "T00:00:00Z/" +
      interval +
      "&agg=" +
      sumormean,
    function (textt) {
      var obj = JSON.parse(textt);
      const downloaddaten_2median = [];
      for (var i in obj) {
        if (obj[i].v != null) {
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].v,
            downloaddaten_median
          );
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].hi,
            downloaddaten_max
          );
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].lo,
            downloaddaten_min
          );
        }
      }

      if (minmax == 0) downloaddaten_graph = downloaddaten_median;
      if (minmax == 1) downloaddaten_graph = downloaddaten_min;
      if (minmax == 2) downloaddaten_graph = downloaddaten_max;

      if (
        elem == "BF" &&
        minmax == 0 &&
        sumormean == "mean" &&
        interval == "P1D"
      ) {
        if (document.getElementById("levelII").innerHTML == "true") {
          readTextFile(
            "https://life.hydro.tu-dresden.de/bfa_out/WKS_SN/theta_sim/" +
              document.getElementById("SAbk").innerHTML +
              ".json",
            function (textsim) {
              var objsim = JSON.parse(textsim);

              for (var i in objsim) {
                if (
                  datePickerDate.getTime() <= objsim[i].datetimeposix * 1000 &&
                  dd.getTime() > objsim[i].datetimeposix * 1000
                ) {
                  storeDownloadData(
                    objsim[i].datetimeposix * 1000,
                    objsim[i].Wessolek_0_60 * 100,
                    downloaddaten_2median
                  );
                }
              }

              ApexCharts.exec(
                "downloaddata",
                "updateOptions",
                {
                  yaxis: {
                    //type: 'datetime',
                    title: { text: name },
                    //min: new Date(startdate).getTime(),
                    //tickAmount: 12
                  },
                  title: {
                    text: name,
                    //align: 'left',
                  },
                },
                false,
                true
              );
              ApexCharts.exec("downloaddata", "updateSeries", [
                {
                  name: "gemessen",
                  type: "line",
                  data: downloaddaten_median,
                },
                {
                  name: "simuliert",
                  type: "line",
                  data: downloaddaten_2median,
                },
              ]);
            }
          );
        } else {
          readTextFile(
            "https://life.hydro.tu-dresden.de/bfa_out/WKS_SN/theta_sim/" +
              document.getElementById("SAbk").innerHTML +
              ".json",
            function (textsim) {
              var objsim = JSON.parse(textsim);
              for (var i in objsim) {
                if (
                  datePickerDate.getTime() <= objsim[i].datetimeposix * 1000 &&
                  dd.getTime() > objsim[i].datetimeposix * 1000
                ) {
                  storeDownloadData(
                    objsim[i].datetimeposix * 1000,
                    objsim[i].Wessolek_0_60 * 100,
                    downloaddaten_2median
                  );
                }
              }

              ApexCharts.exec(
                "downloaddata",
                "updateOptions",
                {
                  yaxis: {
                    //type: 'datetime',
                    title: { text: name },
                    //min: new Date(startdate).getTime(),
                    //tickAmount: 12
                  },
                  title: {
                    text: name,
                    //align: 'left',
                  },
                },
                false,
                true
              );
              ApexCharts.exec("downloaddata", "updateSeries", [
                {
                  name: "gemessen",
                  type: "line",
                  data: downloaddaten_median,
                },
                {
                  name: "simuliert",
                  type: "line",
                  data: downloaddaten_2median,
                },
              ]);
            }
          );
        }
      } else {
        ApexCharts.exec(
          "downloaddata",
          "updateOptions",
          {
            chart: {
              //height: 350,
              type: "line",
            },
            stroke: {
              width: 2,
            },
            yaxis: {
              //type: 'datetime',
              title: { text: name },
              //min: new Date(startdate).getTime(),
              //tickAmount: 12
            },
            title: {
              text: name,
              //align: 'left',
            },
          },
          false,
          true
        );

        if (elem === "RR" && minmax == 0) {
          ApexCharts.exec("downloaddata", "updateSeries", [
            {
              name: "Data",
              type: "column",
              data: downloaddaten_median,
            },
          ]);
        } else if (elem === "RR" && minmax == 1) {
          ApexCharts.exec("downloaddata", "updateSeries", [
            {
              name: "Data",
              type: "column",
              data: downloaddaten_min,
            },
          ]);
        } else if (elem === "RR" && minmax == 2) {
          ApexCharts.exec("downloaddata", "updateSeries", [
            {
              name: "Data",
              type: "column",
              data: downloaddaten_max,
            },
          ]);
        } else if (elem == "TT" && minmax == 0 && sumormean == "mean") {
          if (interval != "P1H") {
            ApexCharts.exec("downloaddata", "updateSeries", [
              {
                name: "Tagesmittel",
                type: "line",
                data: downloaddaten_median,
              },
              { name: "Minimum", type: "line", data: downloaddaten_min },
              { name: "Maximum", type: "line", data: downloaddaten_max },
            ]);
          } else {
            ApexCharts.exec("downloaddata", "updateSeries", [
              {
                name: "Tagesmittel",
                type: "line",
                data: downloaddaten_graph,
              },
            ]);
          }
        } else {
          ApexCharts.exec("downloaddata", "updateSeries", [
            {
              name: "Data",
              type: "line",
              data: downloaddaten_graph,
            },
          ]);
        }
      }
    }
  );
};

window.downloadclick2 = function (
  elem,
  name,
  years,
  daysback,
  interval,
  numberinterval,
  sumormean,
  button,
  buttoncheck,
  minmax
) {
  document.getElementById("timeserieslength2").innerHTML = years.toString();
  document.getElementById("numofinterval2").innerHTML =
    numberinterval.toString();
  if (sumormean.toString() == "sum") {
    document.getElementById("summean2").innerHTML = sumormean.toString();
  } else if (sumormean.toString() == "summ") {
    sumormean = "sum";
  }
  if (sumormean.toString() == "mean") {
    document.getElementById("summean2").innerHTML = sumormean.toString();
  } else if (sumormean.toString() == "meann") {
    sumormean = "mean";
  }

  if (sumormean.toString() == "sum") {
    document.getElementById("Aggregierung2").options.selectedIndex = 0;
  } else {
    document.getElementById("Aggregierung2").options.selectedIndex = 1;
  }
  if (minmax == 1)
    document.getElementById("Aggregierung2").options.selectedIndex = 2; //min=1
  if (minmax == 2)
    document.getElementById("Aggregierung2").options.selectedIndex = 3; //max=2
  document.getElementById("aggre2").innerHTML = interval.toString();

  document.getElementById("Export2").disabled = true;

  if (buttoncheck == "1") {
    const buttons = document.querySelectorAll(".buttonA2");
    buttons.forEach((butt) => {
      butt.style.backgroundColor = "#5b9ad5";
    });
    //document.getElementById(button).style.backgroundColor = '#4479ab';
    const buttonss = document.querySelectorAll(".buttonT2");
    buttonss.forEach((butts) => {
      butts.style.backgroundColor = "#5b9ad5";
    });
    document.getElementById(button).style.backgroundColor = "#4479ab";

    if (button == "But5j2" || button == "But2j2") {
      document.getElementById("Export2").disabled = true;
    } else {
      document.getElementById("Export2").disabled = true;
    }
  } else if (buttoncheck == "2") {
    const buttons = document.querySelectorAll(".buttonT2");
    buttons.forEach((butt) => {
      butt.style.backgroundColor = "#5b9ad5";
    });
    document.getElementById(button).style.backgroundColor = "#4479ab";
  } else if (buttoncheck == "3") {
    const buttons1 = document.querySelectorAll(".buttonT2");
    buttons1.forEach((butt1) => {
      butt1.style.backgroundColor = "#5b9ad5";
    });
    const buttonsss = document.querySelectorAll(".buttonA2");
    buttonsss.forEach((buttss) => {
      buttss.style.backgroundColor = "#5b9ad5";
    });
  }

  ApexCharts.exec("downloaddata2", "updateSeries", [{ data: [] }], true);

  const downloaddaten_median = [];
  const downloaddaten_min = [];
  const downloaddaten_max = [];
  var downloaddaten_graph = [];

  var dd = new Date(document.getElementById("Input_Date2b").value);
  var datePickerDate = new Date(document.getElementById("Input_Date2").value);
  var diffdate = Math.round(
    (dd.getTime() - datePickerDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  var DATUMP = document.getElementById("Input_Date2").value;
  if (interval == "P1H") {
    var d = new Date();
    var df = new Date();
    df.setDate(df.getDate() - 30);
    var monati = df.getMonth() + 1;
    if (monati < 10) {
      monati = "0" + (df.getMonth() + 1);
    }
    var tagi = df.getDate();
    if (tagi < 10) {
      tagi = "0" + df.getDate();
    }
    if (interval == "P1Y") {
      monati = "01";
      tagi = "01";
    }
    DATUMP = d.getFullYear() + "-" + monati + "-" + tagi;

    diffdate = Math.round((d.getTime() - df.getTime()) / (1000 * 60 * 60));
  }

  var numbInt = "R" + diffdate;

  //alert('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+document.getElementById("station").innerHTML+'/sensors/'+elem+'/measurements?interval='+numbInt+'/'+DATUMP+'T00:00:00Z/'+interval+'&agg='+sumormean);
  readTextFile(
    "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
      document.getElementById("station").innerHTML +
      "/sensors/" +
      elem +
      "/measurements?interval=" +
      numbInt +
      "/" +
      DATUMP +
      "T00:00:00Z/" +
      interval +
      "&agg=" +
      sumormean,
    function (textt) {
      var obj = JSON.parse(textt);
      const downloaddaten_2median = [];
      for (var i in obj) {
        if (obj[i].v != null) {
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].v,
            downloaddaten_median
          );
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].hi,
            downloaddaten_max
          );
          storeDownloadData(
            new Date(obj[i].begin).valueOf(),
            obj[i].lo,
            downloaddaten_min
          );
        }
      }
      if (minmax == 0) downloaddaten_graph = downloaddaten_median;
      if (minmax == 1) downloaddaten_graph = downloaddaten_min;
      if (minmax == 2) downloaddaten_graph = downloaddaten_max;

      if (
        elem == "BF" &&
        minmax == 0 &&
        sumormean == "mean" &&
        interval == "P1D"
      ) {
        if (document.getElementById("levelII").innerHTML == "true") {
          readTextFile(
            "https://life.hydro.tu-dresden.de/bfa_out/WKS_SN/theta_sim/" +
              document.getElementById("SAbk").innerHTML +
              ".json",
            function (textsim) {
              var objsim = JSON.parse(textsim);
              for (var ii in objsim) {
                if (
                  datePickerDate.getTime() <= objsim[ii].datetimeposix * 1000 &&
                  dd.getTime() > objsim[ii].datetimeposix * 1000
                ) {
                  storeDownloadData(
                    objsim[ii].datetimeposix * 1000,
                    objsim[ii].Wessolek_0_60 * 100,
                    downloaddaten_2median
                  );
                }
              }

              ApexCharts.exec(
                "downloaddata2",
                "updateOptions",
                {
                  yaxis: {
                    //type: 'datetime',
                    title: { text: name },
                    //min: new Date(startdate).getTime(),
                    //tickAmount: 12
                  },
                  title: {
                    text: name,
                    //align: 'left',
                  },
                },
                false,
                true
              );
              ApexCharts.exec("downloaddata2", "updateSeries", [
                {
                  name: "gemessen",
                  type: "line",
                  data: downloaddaten_median,
                },
                {
                  name: "simuliert",
                  type: "line",
                  data: downloaddaten_2median,
                },
              ]);
            }
          );
        } else {
          readTextFile(
            "https://life.hydro.tu-dresden.de/bfa_out/WKS_SN/theta_sim/" +
              document.getElementById("SAbk").innerHTML +
              ".json",
            function (textsim) {
              var objsim = JSON.parse(textsim);

              for (var iii in objsim) {
                if (
                  datePickerDate.getTime() <=
                    objsim[iii].datetimeposix * 1000 &&
                  dd.getTime() > objsim[iii].datetimeposix * 1000
                ) {
                  storeDownloadData(
                    objsim[iii].datetimeposix * 1000,
                    objsim[iii].Wessolek_0_60 * 100,
                    downloaddaten_2median
                  );
                }
              }

              ApexCharts.exec(
                "downloaddata2",
                "updateOptions",
                {
                  yaxis: {
                    //type: 'datetime',
                    title: { text: name },
                    //min: new Date(startdate).getTime(),
                    //tickAmount: 12
                  },
                  title: {
                    text: name,
                    //align: 'left',
                  },
                },
                false,
                true
              );
              ApexCharts.exec("downloaddata2", "updateSeries", [
                {
                  name: "gemessen",
                  type: "line",
                  data: downloaddaten_median,
                },
                {
                  name: "simuliert",
                  type: "line",
                  data: downloaddaten_2median,
                },
              ]);
            }
          );
        }
      } else {
        ApexCharts.exec(
          "downloaddata2",
          "updateOptions",
          {
            chart: {
              //height: 350,
              type: "line",
            },
            stroke: {
              width: 2,
            },
            yaxis: {
              //type: 'datetime',
              title: { text: name },
              //min: new Date(startdate).getTime(),
              //tickAmount: 12
            },
            title: {
              text: name,
              //align: 'left',
            },
          },
          false,
          true
        );

        if (elem == "RR" && minmax == 0) {
          ApexCharts.exec("downloaddata2", "updateSeries", [
            {
              name: "Data",
              type: "column",
              data: downloaddaten_median,
            },
          ]);
        } else if (elem == "TT" && minmax == 0 && sumormean == "mean") {
          if (interval != "P1H") {
            ApexCharts.exec("downloaddata2", "updateSeries", [
              {
                name: "Tagesmittel",
                type: "line",
                data: downloaddaten_median,
              },
              { name: "Minimum", type: "line", data: downloaddaten_min },
              { name: "Maximum", type: "line", data: downloaddaten_max },
            ]);
          } else {
            ApexCharts.exec("downloaddata2", "updateSeries", [
              {
                name: "Tagesmittel",
                type: "line",
                data: downloaddaten_graph,
              },
            ]);
          }
        } else {
          ApexCharts.exec("downloaddata2", "updateSeries", [
            {
              name: "Data",
              type: "line",
              data: downloaddaten_graph,
            },
          ]);
        }
      }
    }
  );
};

window.addEventListener("DOMContentLoaded", function () {
  document.getElementById("droppi").innerHTML =
    '<a href=\'#\' onclick=\'downloadclick("TT","Temperatur [°C]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="TT";document.getElementById("elementunit").innerHTML="Temperatur [°C]";\'>Temperatur</a><a href=\'#\' onclick=\'downloadclick("RR","Niederschlag [mm]",1,365,"P1D","R365","sum", "ButAj1","1","0");document.getElementById("elementline").innerHTML="RR";document.getElementById("elementunit").innerHTML="Niederschlag [mm]";\'>Niederschlag</a><a href=\'#\' onclick=\'downloadclick("GS","Globalstrahlung [W/m²]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="GS";document.getElementById("elementunit").innerHTML="Globalstrahlung [W/m²]";\'>Globalstrahlung</a><a href=\'#\' onclick=\'downloadclick("FX","Maximal Windgeschwindigkeit [m/s]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="FX";document.getElementById("elementunit").innerHTML="Maximal Windgeschwindigkeit [m/s]";\'>Maximal Windgeschwindigkeit</a><a href=\'#\' onclick=\'downloadclick("FF","Windgeschwindigkeit [m/s]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="FF";document.getElementById("elementunit").innerHTML="Windgeschwindigkeit [m/s]";\'>Windgeschwindigkeit</a><a href=\'#\' onclick=\'downloadclick("RH","Relative Feuchte [%]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="RH";document.getElementById("elementunit").innerHTML="Relative Feuchte [%]";\'>Relative Feuchte</a><a href=\'#\' onclick=\'downloadclick("TG","Bodentemperatur 5cm über Grund [°C]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="TG";document.getElementById("elementunit").innerHTML="Bodentemperatur [°C]";\'>Bodentemperatur 5cm über Grund</a><a href=\'#\' onclick=\'downloadclick("BF","Bodenfeuchte [%]",1,365,"P1D","R365","mean", "ButAj1","1","0");document.getElementById("elementline").innerHTML="BF";document.getElementById("elementunit").innerHTML="Bodenfeuchte [%]";\'>Bodenfeuchte</a>';

  document.getElementById("droppi2").innerHTML =
    '<a href=\'#\' onclick=\'downloadclick2("TT","Temperatur [°C]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="TT";document.getElementById("elementunit2").innerHTML="Temperatur [°C]";\'>Temperatur</a><a href=\'#\' onclick=\'downloadclick2("RR","Niederschlag [mm]",1,365,"P1D","R365","sum", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="RR";document.getElementById("elementunit2").innerHTML="Niederschlag [mm]";\'>Niederschlag</a><a href=\'#\' onclick=\'downloadclick2("GS","Globalstrahlung [W/m²]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="GS";document.getElementById("elementunit2").innerHTML="Globalstrahlung [W/m²]";\'>Globalstrahlung</a><a href=\'#\' onclick=\'downloadclick2("FX","Maximal Windgeschwindigkeit [m/s]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="FX";document.getElementById("elementunit2").innerHTML="Maximal Windgeschwindigkeit [m/s]";\'>Maximal Windgeschwindigkeit</a><a href=\'#\' onclick=\'downloadclick2("FF","Windgeschwindigkeit [m/s]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="FF";document.getElementById("elementunit2").innerHTML="Windgeschwindigkeit [m/s]";\'>Windgeschwindigkeit</a><a href=\'#\' onclick=\'downloadclick2("RH","Relative Feuchte [%]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="RH";document.getElementById("elementunit2").innerHTML="Relative Feuchte [%]";\'>Relative Feuchte</a><a href=\'#\' onclick=\'downloadclick2("TG","Bodentemperatur 5cm über Grund [°C]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="TG";document.getElementById("elementunit2").innerHTML="Bodentemperatur [°C]";\'>Bodentemperatur 5cm über Grund</a><a href=\'#\' onclick=\'downloadclick2("BF","Bodenfeuchte [%]",1,365,"P1D","R365","mean", "ButAj2","1","0");document.getElementById("elementline2").innerHTML="BF";document.getElementById("elementunit2").innerHTML="Bodenfeuchte [%]";\'>Bodenfeuchte</a>';

  var datumdat = new Date();

  var dd = datumdat.getDate();
  var mm = datumdat.getMonth() + 1; //January is 0!
  var yyyy = datumdat.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  var today = yyyy + "-" + mm + "-" + dd;
  var past = "2017-01-01";
  datumdat.setDate(datumdat.getDate() - 7);

  document.getElementById("Input_Date1").valueAsDate = datumdat;
  document.getElementById("Input_Date2").valueAsDate = datumdat;
  document.getElementById("Input_Date1b").valueAsDate = new Date();
  document.getElementById("Input_Date2b").valueAsDate = new Date();
  document.getElementById("Input_Date1").setAttribute("max", today);
  document.getElementById("Input_Date2").setAttribute("max", today);
  document.getElementById("Input_Date1").setAttribute("min", past);
  document.getElementById("Input_Date2").setAttribute("min", past);
  document.getElementById("Input_Date1b").setAttribute("max", today);
  document.getElementById("Input_Date2b").setAttribute("max", today);
  document.getElementById("Input_Date1b").setAttribute("min", past);
  document.getElementById("Input_Date2b").setAttribute("min", past);

  var aggregier1 = document.getElementById("Aggregierung1");
  aggregier1.addEventListener("change", function () {
    var options = aggregier1.value;
    if (options == "sum")
      downloadclick(
        document.getElementById("elementline").innerHTML,
        document.getElementById("elementunit").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        "summ",
        "ButAj1",
        "1",
        "0"
      );
    if (options == "mean")
      downloadclick(
        document.getElementById("elementline").innerHTML,
        document.getElementById("elementunit").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        "meann",
        "ButAj1",
        "1",
        "0"
      );
    if (options == "min")
      downloadclick(
        document.getElementById("elementline").innerHTML,
        document.getElementById("elementunit").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        document.getElementById("summean").innerHTML,
        "ButAj1",
        "1",
        "1"
      );
    if (options == "max")
      downloadclick(
        document.getElementById("elementline").innerHTML,
        document.getElementById("elementunit").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        document.getElementById("summean").innerHTML,
        "ButAj1",
        "1",
        "2"
      );
  });

  var aggregier2 = document.getElementById("Aggregierung2");
  aggregier2.addEventListener("change", function () {
    var options = aggregier2.value;
    if (options == "sum")
      downloadclick2(
        document.getElementById("elementline2").innerHTML,
        document.getElementById("elementunit2").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        "summ",
        "ButAj2",
        "1",
        "0"
      );
    if (options == "mean")
      downloadclick2(
        document.getElementById("elementline2").innerHTML,
        document.getElementById("elementunit2").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        "meann",
        "ButAj2",
        "1",
        "0"
      );
    if (options == "min")
      downloadclick2(
        document.getElementById("elementline2").innerHTML,
        document.getElementById("elementunit2").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        document.getElementById("summean2").innerHTML,
        "ButAj2",
        "1",
        "1"
      );
    if (options == "max")
      downloadclick2(
        document.getElementById("elementline2").innerHTML,
        document.getElementById("elementunit2").innerHTML,
        1,
        365,
        "P1D",
        "R365",
        document.getElementById("summean2").innerHTML,
        "ButAj2",
        "1",
        "2"
      );
  });
});

// JSON to CSV Converter
function ConvertToCSV(objArray, elename) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "JJJJ-MM-TTTSS:MMZ," + elename + "\n";
  for (var i = 0; i < array.length; i++) {
    var line = "";
    var count = 0;
    for (var index in array[i]) {
      count++;
      if (count <= 2) {
        if (line != "") line += ",";

        line += array[i][index];
      }
    }
    str += line + "\r\n";
  }
  return str;
}

// JSON to CSV Converter
function MultipleConvertToCSV(
  textTT,
  textRR,
  textFF,
  textFX,
  textTG,
  textBF,
  textGS,
  textRH
) {
  //(objArray) {
  var arrayTT = typeof textTT != "object" ? JSON.parse(textTT) : textTT;
  var arrayRR = typeof textRR != "object" ? JSON.parse(textRR) : textRR;
  var arrayFF = typeof textFF != "object" ? JSON.parse(textFF) : textFF;
  var arrayFX = typeof textFX != "object" ? JSON.parse(textFX) : textFX;
  var arrayTG = typeof textTG != "object" ? JSON.parse(textTG) : textTG;
  var arrayBF = typeof textBF != "object" ? JSON.parse(textBF) : textBF;
  var arrayGS = typeof textGS != "object" ? JSON.parse(textGS) : textGS;
  var arrayRH = typeof textRH != "object" ? JSON.parse(textRH) : textRH;

  var str =
    "JJJJ-MM-TTTSS:MMZ,Temperatur [°C],Niederschlag [mm],Windgeschwindigkeit [m/s],Maximale Windgeschwindigkeit [m/s],Bodentemperatur 5cm ü.Grund [°C],Bodenfeuchte [%],Globalstrahlung [W/m²],Luftfeuchtigkeit [%]\n";
  for (var i = 0; i < arrayTT.length; i++) {
    var line = "";
    var count = 0;
    for (var index in arrayTT[i]) {
      count++;
      if (count < 2) {
        if (line != "") line += ",";
        line += arrayTT[i][index];
      }
      if (count == 2) {
        if (line != "") line += ",";
        line +=
          arrayTT[i][index] +
          "," +
          arrayRR[i][index] +
          "," +
          arrayFF[i][index] +
          "," +
          arrayFX[i][index] +
          "," +
          arrayTG[i][index] +
          "," +
          arrayBF[i][index] +
          "," +
          arrayGS[i][index] +
          "," +
          arrayRH[i][index];
      }
    }
    str += line + "\r\n";
  }
  return str;
}

window.saveData = function (
  elem,
  name,
  years,
  interval,
  numberinterval,
  sumormean,
  datpicky,
  datpickyb
) {
  var dd = new Date(document.getElementById(datpickyb).value);
  var datePickerDate = new Date(document.getElementById(datpicky).value);
  var diffdate = Math.round(
    (dd.getTime() - datePickerDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  var DATUMP = document.getElementById(datpicky).value;
  var d = new Date();
  var df = new Date();
  df.setDate(df.getDate() - 30);
  var monati = df.getMonth() + 1;
  if (monati < 10) {
    monati = "0" + (df.getMonth() + 1);
  }
  var tagi = df.getDate();
  if (tagi < 10) {
    tagi = "0" + df.getDate();
  }
  if (interval == "P1Y") {
    monati = "01";
    tagi = "01";
  }
  if (interval == "P1H") {
    //DATUMP=d.getFullYear()+'-'+monati+'-'+tagi;

    diffdate = Math.round(
      (dd.getTime() - datePickerDate.getTime()) / (1000 * 60 * 60)
    );
  }

  var numbInt = "R" + diffdate;
  //alert('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+document.getElementById("station").innerHTML+'/sensors/'+elem+'/measurements?interval='+numbInt+'/'+DATUMP+'T00:00:00Z/'+interval+'&agg='+sumormean);

  if (!document.getElementById("DownloadAllElements").checked) {
    readTextFile(
      "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
        document.getElementById("station").innerHTML +
        "/sensors/" +
        elem +
        "/measurements?interval=" +
        numbInt +
        "/" +
        DATUMP +
        "T00:00:00Z/" +
        interval +
        "&agg=" +
        sumormean,
      function (textt) {
        /*var obj = JSON.parse(textt);  */
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        /*var MIME_TYPE = "text/csv";
					var blob = new Blob([data], {type: MIME_TYPE});*/
        var dattext = ConvertToCSV(textt, name);
        var MIME_TYPE = "text/csv";
        (blob = new Blob(["\ufeff", dattext], { type: MIME_TYPE })),
          (url = window.URL.createObjectURL(blob));
        a.href = url;
        var fileName =
          document.getElementById("stationName").innerHTML +
          "_" +
          name +
          "_" +
          new Date().getFullYear() +
          "_" +
          monati +
          "_" +
          (new Date().getDate() - 1) +
          ".csv";
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    );
  } else if (document.getElementById("DownloadAllElements").checked) {
    readTextFile(
      "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
        document.getElementById("station").innerHTML +
        "/sensors/TT/measurements?interval=" +
        numbInt +
        "/" +
        DATUMP +
        "T00:00:00Z/" +
        interval +
        "&agg=mean",
      function (textTT) {
        readTextFile(
          "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
            document.getElementById("station").innerHTML +
            "/sensors/RR/measurements?interval=" +
            numbInt +
            "/" +
            DATUMP +
            "T00:00:00Z/" +
            interval +
            "&agg=sum",
          function (textRR) {
            readTextFile(
              "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                document.getElementById("station").innerHTML +
                "/sensors/FF/measurements?interval=" +
                numbInt +
                "/" +
                DATUMP +
                "T00:00:00Z/" +
                interval +
                "&agg=mean",
              function (textFF) {
                readTextFile(
                  "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                    document.getElementById("station").innerHTML +
                    "/sensors/FX/measurements?interval=" +
                    numbInt +
                    "/" +
                    DATUMP +
                    "T00:00:00Z/" +
                    interval +
                    "&agg=mean",
                  function (textFX) {
                    readTextFile(
                      "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                        document.getElementById("station").innerHTML +
                        "/sensors/TG/measurements?interval=" +
                        numbInt +
                        "/" +
                        DATUMP +
                        "T00:00:00Z/" +
                        interval +
                        "&agg=mean",
                      function (textTG) {
                        readTextFile(
                          "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                            document.getElementById("station").innerHTML +
                            "/sensors/BF/measurements?interval=" +
                            numbInt +
                            "/" +
                            DATUMP +
                            "T00:00:00Z/" +
                            interval +
                            "&agg=mean",
                          function (textBF) {
                            readTextFile(
                              "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                                document.getElementById("station").innerHTML +
                                "/sensors/GS/measurements?interval=" +
                                numbInt +
                                "/" +
                                DATUMP +
                                "T00:00:00Z/" +
                                interval +
                                "&agg=mean",
                              function (textGS) {
                                readTextFile(
                                  "https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/" +
                                    document.getElementById("station")
                                      .innerHTML +
                                    "/sensors/RH/measurements?interval=" +
                                    numbInt +
                                    "/" +
                                    DATUMP +
                                    "T00:00:00Z/" +
                                    interval +
                                    "&agg=mean",
                                  function (textRH) {
                                    var objTT = JSON.parse(textTT);
                                    var objRR = JSON.parse(textRR);
                                    var objFF = JSON.parse(textFF);
                                    var objFX = JSON.parse(textFX);
                                    var objTG = JSON.parse(textTG);
                                    var objBF = JSON.parse(textBF);
                                    var objGS = JSON.parse(textGS);
                                    var objRH = JSON.parse(textRH);

                                    var a = document.createElement("a");
                                    document.body.appendChild(a);
                                    a.style = "display: none";
                                    /*var MIME_TYPE = "text/csv";
											var blob = new Blob([data], {type: MIME_TYPE});*/
                                    var dattext = MultipleConvertToCSV(
                                      textTT,
                                      textRR,
                                      textFF,
                                      textFX,
                                      textTG,
                                      textBF,
                                      textGS,
                                      textRH
                                    );
                                    var MIME_TYPE = "text/csv";
                                    (blob = new Blob(["\ufeff", dattext], {
                                      type: MIME_TYPE,
                                    })),
                                      (url = window.URL.createObjectURL(blob));
                                    a.href = url;
                                    var fileName =
                                      document.getElementById("stationName")
                                        .innerHTML +
                                      "_alleElemente_" +
                                      new Date().getFullYear() +
                                      "_" +
                                      monati +
                                      "_" +
                                      (new Date().getDate() - 1) +
                                      ".csv";
                                    a.download = fileName;
                                    a.click();
                                    window.URL.revokeObjectURL(url);
                                  }
                                );
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                );
              }
            );
          }
        );
      }
    );
  }
};

document.querySelectorAll(".faq-toggle").forEach(function (toggle) {
  toggle.addEventListener("click", function () {
    this.classList.toggle("active");
    this.nextElementSibling.classList.toggle("active");
  });
});

function toggleSubmenu(event) {
  event.preventDefault();
  var submenu = event.target.nextElementSibling;
  submenu.classList.toggle("show");
}

// JavaScript
document.querySelectorAll(".myChartdiv-child").forEach(function (child) {
  child.addEventListener("click", function () {
    // Hide all child divs
    document.querySelectorAll(".myChartdiv-child").forEach(function (sibling) {
      sibling.style.visibility = "hidden";
    });

    // Show the clicked child div
    child.style.visibility = "visible";
  });
});

// Define panels array in global scope
var panels = [
  "SoilMoisturePanel",
  "DownloadPanel",
  "SoilMoistureDummyPanel",
  "SoilMoistureImpressumPanel",
  "statuss",
  "SoilMoistureAboutPanel",
  "FAQ",
  "Bodenprofilpic",
  "Publikationen",
  "GlossarPanel",
  "BaumartenPanel",
];

document.addEventListener("DOMContentLoaded", function () {
  // Get all nav-bar links and the link in the body
  var links = document.querySelectorAll(
    ".navbar-nav .nav-item a:not(#datenplattform-link), .dropdown-item:not(#datenplattform-link), #body-link-publikationen"
  );

  // Hide all panels
  panels.forEach(function (panelId) {
    var panel = document.getElementById(panelId);
    if (panel) panel.style.visibility = "hidden";
  });

  // Show 'SoilMoistureDummyPanel' by default
  var defaultPanel = document.getElementById("SoilMoistureDummyPanel");
  if (defaultPanel) defaultPanel.style.visibility = "visible";

  // Function to change panel visibility
  function changePanelVisibility(event) {
    event.preventDefault();

    // Hide all panels
    panels.forEach(function (panelId) {
      var panel = document.getElementById(panelId);
      if (panel) panel.style.visibility = "hidden";
    });

    // Show selected panel
    var selectedPanelId = this.getAttribute("data-panel");
    var selectedPanel = document.getElementById(selectedPanelId);
    if (selectedPanel) selectedPanel.style.visibility = "visible";
  }

  // Add event listener to each link
  links.forEach(function (link) {
    link.addEventListener("click", changePanelVisibility);
  });
  // Add this at the bottom of your existing code
  document.body.addEventListener("click", function (event) {
    if (event.target && event.target.id.startsWith("body-link-")) {
      // Prevent the default action of the link
      event.preventDefault();

      // Hide all panels
      panels.forEach(function (panelId) {
        var panel = document.getElementById(panelId);
        if (panel) panel.style.visibility = "hidden";
      });

      // Show selected panel
      var selectedPanelId = event.target.getAttribute("data-panel");
      var selectedPanel = document.getElementById(selectedPanelId);
      if (selectedPanel) selectedPanel.style.visibility = "visible";
    }
  });
  // Special handling for Datenplattform link
  var datenplattformLink = document.querySelector("#datenplattform-link");
  datenplattformLink.addEventListener("click", function (event) {
    // Just let the browser handle the link
  });
});

// // Define showPanelById function in global scope
// function showPanelById(panelId) {
//   // Hide all panels
//   panels.forEach(function (panelId) {
//     var panel = document.getElementById(panelId);
//     if (panel) panel.style.visibility = "hidden";
//   });

//   // Show selected panel
//   var selectedPanel = document.getElementById(panelId);
//   if (selectedPanel) selectedPanel.style.visibility = "visible";
// }

// document.addEventListener("DOMContentLoaded", function () {
//   // Get the anchor tag by its id
//   var anchorTag = document.getElementById("showSoilMoisturePanel");

//   // Add an event listener to the anchor tag
//   anchorTag.addEventListener("click", function () {
//     showPanelById("SoilMoisturePanel");
//   });
// });

$(document).ready(function () {
  adjustMapHeight();
  $(window).resize(adjustMapHeight);
});

function adjustMapHeight() {
  if ($(window).width() > 767) {
    var rightHeight = $(".main-content .right").height();
    $(".main-content .left").height(rightHeight * 0.76);
  } else {
    $(".main-content .left").height("auto");
  }
}

var today = new Date();
var year = today.getFullYear();

var copyrightElement1 = document.getElementById("copyright1");
copyrightElement1.textContent =
  "\u00A9 " + year + " Lehrstuhl für Meteorologie TU Dresden - Sachsenforst";

var copyrightElement2 = document.getElementById("copyright2");
copyrightElement2.textContent = "\u00A9 " + year;
